import React from "react";
import { PrimeReactProvider } from "primereact/api";

import Router from "./Router";

import "./i18n";

const App = () => {
  return (
    <PrimeReactProvider>
      <Router />
    </PrimeReactProvider>
  );
};

export default App;
